import Icon from "../ui/Icon";
import { Input } from "../../components/ui/Input";
import type { SearchInputProps } from "../../types";
import { useEffect, useRef, KeyboardEvent, useCallback } from "react";

export default function SearchInput({
  isOpen,
  onClose,
  searchQuery,
  onSearchChange,
  onEnter,
  placeholder = "جستجو در صفحه...",
}: SearchInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleGlobalKeyDown = (e: globalThis.KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleGlobalKeyDown as any);

    return () => {
      document.removeEventListener("keydown", handleGlobalKeyDown as any);
    };
  }, [isOpen, onClose]);

  const handleKeyPress = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter" && searchQuery.trim()) {
        onEnter();
      }
    },
    [searchQuery, onEnter],
  );

  const handleChange = useCallback(
    (value: string) => {
      onSearchChange(value);

      if (value.trim()) {
        onEnter();
      }
    },
    [onSearchChange, onEnter],
  );

  if (!isOpen) return null;

  return (
    <div className="flex w-full items-center justify-end gap-x-2 transition-all duration-300 animate-in slide-in-from-right-5">
      <div className="relative flex-1 w-full md:max-w-[50%]">
        <div className="relative">
          <Input
            ref={inputRef}
            type="text"
            value={searchQuery}
            onChange={(e) => handleChange(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder={placeholder}
            className="pr-3 pl-7 py-2 h-9 w-full font-estedad text-xs placeholder:text-[9px] xl:placeholder:text-xs font-semibold bg-white text-green-05 border-green-02 focus:border-green-05 focus:ring-green-05/20"
            dir="rtl"
            aria-label="جستجو در محتوای صفحه"
          />

          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <Icon icon="Search" className="size-3 xl:size-4 text-green-05" />
          </div>
        </div>
      </div>
      <button
        onClick={onClose}
        className="flex items-center justify-center size-8 hover:bg-green-02/80 transition-colors text-green-05 hover:text-green-05/80 shrink-0 bg-green-02 rounded-full"
        aria-label="بستن جستجو"
        title="بستن (Esc)"
      >
        <Icon icon="X" className="size-2" />
      </button>
    </div>
  );
}
